/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'

import { API } from '../api/api'
import { fetch, post } from '../api/httpClient'
import {
  CUSTOM_PAYMENT,
  DATEFORMAT,
  DATEFORMATWITHTIME,
  MESSAGE_SEVERITIES,
} from '../helpers/constants'
import { selectIntrospect, selectPayment, selectSchool } from '../helpers/selectors'
import { formatDate, isNullOrEmpty } from '../helpers/utils'
import ActionTypes from './actionTypes'
import { messageAction } from './app.action'

export const transactionAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.TRANSACTION,
    data,
  })

export const paymentAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.PAYMENT_APPLICATION_ID,
    data,
  })

export const fetchAppId = (successCallback, failureCallback) => async (dispatch, getState) => {
  try {
    const state = getState()
    const school = selectSchool(state)
    const { data } = await fetch(`${API.PAYMENT.APPID}/${school.sch_school_public_id}`)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
    if (!isEmpty(data)) {
      dispatch(paymentAction(data))
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const fetchPaymentGateways =
  (params, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const payment = selectPayment(state)
      const introspect = selectIntrospect(state)
      const appId = get(payment, 'app_id', '')
      if (isEmpty(appId)) {
        return
      }
      const config = {
        headers: {
          'Application-ID': appId,
        },
      }
      let url = `${API.PAYMENT.GATEWAYLIST}?amount=${params?.amount?.toString() || ''}`
      if (params.is_recurring) {
        url += `&is_recurring=${params.is_recurring || {}}`
      }
      if (params.is_onetime) {
        url += `&is_onetime=${params.is_onetime || {}}`
      }
      let { data } = await fetch(url, config)
      if (isEmpty(data)) {
        data = []
      }
      const mappedData = data.map((item) => ({
        ...item,
        active: Boolean(item.active),
      }))

      const datas = !introspect?.session_metadata?._adminInitializedSession
        ? mappedData.filter(
            (item) =>
              item.gateway_master_alias !== CUSTOM_PAYMENT || item.show_to_admin_only === 'all'
          )
        : mappedData

      if (typeof successCallback === 'function') {
        successCallback(datas)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchTransactionFailureDetails =
  (payload, successCallback, failureCallback) => async () => {
    try {
      const { data } = await fetch(
        `${API.PAYMENT.TRANSACTIONFAILUREDETAILS}?subscription_id=${payload.subId}&charge_id=${payload.chargeId}`
      )

      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const initiatePayment =
  (payload, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const payment = selectPayment(state)
      const app_id = get(payment, 'app_id', '')
      const config = {
        headers: {
          'Application-ID': app_id,
        },
      }
      const url = API.PAYMENT.INITIATETRANSACTIONCORE
      const { data } = await post(url, payload, config)
      if (typeof successCallback === 'function') {
        successCallback(get(data, 'approval_url', ''))
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const initiatePaymentFunded =
  (payload, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const payment = selectPayment(state)
      const app_id = get(payment, 'app_id', '')
      const config = {
        headers: {
          'Application-ID': app_id,
        },
      }
      const url = API.PAYMENT.INITIATETRANSACTIONCOREFUNDED
      const { data } = await post(url, payload, config)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const initiateRePayment =
  (payload, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const payment = selectPayment(state)
      const app_id = get(payment, 'app_id', '')
      const config = {
        headers: {
          'Application-ID': app_id,
        },
      }
      const url = API.PAYMENT.INITIATERETRANSACTIONCORE
      const { data } = await post(url, payload, config)
      if (typeof successCallback === 'function') {
        successCallback(get(data, 'approval_url', ''))
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const prePayment = (payload, successCallback, failureCallback) => async () => {
  try {
    const url = API.PAYMENT.PREPAYMENT
    const { data } = await post(url, payload)
    if (typeof successCallback === 'function') {
      successCallback(get(data, 'approval_url', ''))
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const inactiveSubscriptionPrePayment =
  (payload, successCallback, failureCallback) => async () => {
    try {
      const url = API.PAYMENT.INACTIVE_SUBSCRIPTION_PREPAYMENT
      const { data } = await post(url, payload)
      if (typeof successCallback === 'function') {
        successCallback(get(data, 'approval_url', ''))
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchAllTransactionsCall =
  (pageDetails, successCallback, failureCallback) => async () => {
    try {
      let url = `${API.CORE.TRANSACTION}?page=${pageDetails.current_page || ''}&perPage=${
        pageDetails.per_page || ''
      }&sortBy=${pageDetails.sort_by || ''}&sortOrder=${pageDetails.sort_order || ''}&q=${
        pageDetails.q || ''
      }`
      if (pageDetails.districtId) {
        url += `&districtId=${pageDetails.districtId || ''}`
      }
      if (pageDetails.schoolId) {
        url += `&schoolId=${pageDetails.schoolId || ''}`
      }
      if (pageDetails.enrollmentId) {
        url += `&enrollmentId=${pageDetails.enrollmentId || ''}`
      }
      if (pageDetails.fromDate) {
        url += `&fromDate=${moment(pageDetails.fromDate).format('YYYY-MM-DD')}T00:00:00`
      }
      if (pageDetails.toDate) {
        url += `&toDate=${moment(pageDetails.toDate).format('YYYY-MM-DD')}T23:59:59`
      }
      if (pageDetails.status) {
        url += `&status=${pageDetails.status || ''}`
      }
      if (pageDetails.paymentType) {
        url += `&paymentType=${pageDetails.paymentType || ''}`
      }
      if (pageDetails.feeType) {
        url += `&feeType=${pageDetails.feeType || ''}`
      }
      if (pageDetails.paymentMode) {
        url += `&paymentMode=${pageDetails.paymentMode || ''}`
      }
      const { data } = await fetch(url)
      get(data, 'content', []).forEach((item) => modifyTransactions(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchTransactionDetail = (id, successCallback, failureCallback) => async () => {
  try {
    const { data } = await fetch(`${API.PAYMENT.FETCHTRANSACTIONDETAILS}/${id}`)
    modifyTransactionDetails(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const fetchEnrollmentRecurringPayment =
  (enrId, successCallback, failureCallback) => async () => {
    try {
      const { data } = await fetch(`${API.PAYMENT.INVOICERECURRINGDETAILS}/${enrId}`)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchRecurringPaymentDetails = (successCallback, failureCallback) => async () => {
  try {
    const { data } = await fetch(API.PAYMENT.INVOICERECURRINGDETAILS)
    if (typeof successCallback === 'function') {
      data?.forEach((item) => {
        item.inv_billing_next_date = item.inv_billing_next_date
          ? formatDate(item.inv_billing_next_date, DATEFORMAT)
          : ''
      })
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const fetchRecurringPaymentCardDetails =
  (id, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.PAYMENT.FETCHENROLLMENTRECURRINGCARDDETAILS}/${id}`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }
export const requestExtensionFeeCall =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    try {
      const { data } = await post(API.CORE.EXTENSION_REQUEST, payload)
      if (typeof successCallback === 'function') {
        successCallback(data)
        dispatch(
          messageAction({
            subTitle: 'message:extensionRequestSent',
            severity: MESSAGE_SEVERITIES.SUCCESS,
          })
        )
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }
export const updateCardDetails =
  (payload, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const payment = selectPayment(state)
      const app_id = get(payment, 'app_id', '')
      const config = {
        headers: {
          'Application-ID': app_id,
        },
      }
      const { data } = await post(API.PAYMENT.UPDATECARDDETAILS, payload, config)
      if (data.approval_url) {
        // eslint-disable-next-line require-atomic-updates
        window.location = data.approval_url
      }
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const payAdditionalFee = (payload, successCallback, failureCallback) => async (dispatch) => {
  try {
    const url = API.PAYMENT.ADDITIONALFEE
    const config = {
      headers: {
        'Application-ID': payload.app_id,
      },
    }
    delete payload.app_id
    const { data } = await post(url, payload, config)
    if (typeof successCallback === 'function') {
      successCallback(get(data, 'approval_url', ''))
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
    dispatch(
      messageAction({
        title: 'error:errorPayment',
        subTitle: 'error:errorPaymentMessage',
        severity: MESSAGE_SEVERITIES.ERROR,
      })
    )
  }
}

export const fetchStateFundInvoices =
  (pageDetails, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.STATE_INVOICES}/${pageDetails.enrollmentId}?&realmName=${
        pageDetails.realmName || ''
      }&page=${pageDetails.current_page || ''}&perPage=${pageDetails.per_page || ''}&sortBy=${
        pageDetails.sort_by || ''
      }&sortOrder=${pageDetails.sort_order || ''}`

      const { data } = await fetch(url)
      // get(data, 'content', []).forEach((item) => modifyTransactions(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const verifyVoucherCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const apiPath = `${API.PAYMENT.VERIFY_VOUCHER}/${payload.voucherCode}?program_id=${payload.programId}`
    const { data } = await fetch(apiPath)

    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const modifyTransactionDetails = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.txn_status = (item.txn_status || '').toLowerCase()
  item.createdTimeLabel = formatDate(item?.txn_created_at, DATEFORMATWITHTIME)
  item.updatedTimeLabel = formatDate(item?.txn_updated_at, DATEFORMATWITHTIME)
}

const modifyTransactions = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.id = item.txn_id.toString()
  item.createdTimeLabel = formatDate(item.txn_created_at, DATEFORMATWITHTIME)
  item.updatedTimeLabel = formatDate(item.txn_updated_at, DATEFORMATWITHTIME)
  item.txn_status = (item.txn_status || '').toLowerCase()
  item.txn_meta_data = item?.txn_meta_data ? JSON.parse(item?.txn_meta_data) : ''
  item.txnGatewayResponse = !isNullOrEmpty(item?.txn_gateway_response)
    ? JSON.parse(item?.txn_gateway_response)
    : ''
}
